"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Arrays = _interopRequireDefault(require("./Arrays"));

var _ArrayList = _interopRequireDefault(require("./ArrayList"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Collections = {
  reverseOrder: function reverseOrder() {
    return {
      compare: function compare(a, b) {
        return b.compareTo(a);
      }
    };
  },
  min: function min(l) {
    Collections.sort(l);
    return l.get(0);
  },
  sort: function sort(l, c) {
    var a = l.toArray();

    if (c) {
      _Arrays.default.sort(a, c);
    } else {
      _Arrays.default.sort(a);
    }

    var i = l.iterator();

    for (var pos = 0, alen = a.length; pos < alen; pos++) {
      i.next();
      i.set(a[pos]);
    }
  },
  singletonList: function singletonList(o) {
    var arrayList = new _ArrayList.default();
    arrayList.add(o);
    return arrayList;
  }
};
var _default = Collections;
exports.default = _default;